import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { LoadingScreenComponent } from '@coin/shared/core/data-access';
import { IconButtonComponent } from '@coin/shared/core/ui-storybook';
import { FaqItem } from '@coin/shared/core/util-models';
import { TranslatePipe } from '@ngx-translate/core';
import { FaqMenuComponent } from './faq-menu.component';

/**
 * Loads the FAQ menu (Material tabs, search input) only when it is rendered, keeping it out of the apps' startup bundle.
 * Apps can't @defer the FAQ menu themselves: that would dynamically import the whole auth/feature entry point.
 */
@Component({
  selector: 'coin-lazy-faq-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaqMenuComponent, IconButtonComponent, LoadingScreenComponent, TranslatePipe],
  host: { style: 'display: contents' },
  styleUrl: './lazy-faq-menu.component.scss',
  template: `
    @defer (on immediate) {
      <coin-siemens-energy-faq-menu
        [helpData]="helpData()"
        [isLoading]="isLoading()"
        [isSearchBarVisible]="isSearchBarVisible()"
        (close)="close.emit()"
        (openOtherTopic)="openOtherTopic.emit($event)">
        <ng-content></ng-content>
      </coin-siemens-energy-faq-menu>
    } @placeholder {
      <div class="faq-menu-frame">
        <div class="top-bar">
          <coin-icon-button
            type="secondary"
            icon="close"
            (click)="close.emit()"></coin-icon-button>
        </div>
        <app-loading-screen
          [local]="true"
          [contrast]="true"></app-loading-screen>
      </div>
    } @error {
      <div class="faq-menu-frame">
        <div class="top-bar">
          <coin-icon-button
            type="secondary"
            icon="close"
            (click)="close.emit()"></coin-icon-button>
        </div>
        <p>{{ 'faq.no-faq-load-info' | translate }}</p>
        <p>{{ 'faq.reload-page-info' | translate }}</p>
      </div>
    }
  `
})
export class LazyFaqMenuComponent {
  readonly helpData = input<FaqItem[]>([]);
  readonly isLoading = input(false);
  readonly isSearchBarVisible = input(true);
  // eslint-disable-next-line @angular-eslint/no-output-native
  readonly close = output<void>();
  readonly openOtherTopic = output<string>();
}
